import { FormHelper, i18n, UnsavedChangesPromptActions } from 'invision-core';
import { stateReload } from 'redux-ui-router';
import pathOr from 'ramda/src/pathOr';
import CustomerCareLocaleKeys from '../../../../locales/keys';
import { CurrentHouseholdSelector, HouseholdErrorSelector, IsCreatingHouseholdMemberSelector, SelectedHouseholdMemberIdSelector, SelectedHouseholdMemberSelector } from '../../../../reducers/selectors/customer.household.selectors';
import { CreateCustomerStateRegionProvinceValueOptions, CreateChildCustomerSelector, CurrentCustomerIdSelector, CurrentCustomerAccountingMethodSelector, EnableProspectLiteForHouseholdSelector, SelectedCustomerSubtenantSelector } from '../../../../reducers/selectors/customer.selectors';
import { getErrorLookupObject } from '../../../createCustomer/create.customer.constants';
import { clearCreateEditCustomerForm, createEditCustomerFormChanged } from '../../../../reducers/actions/customer.actions';
import { createHouseholdMember } from '../../../../reducers/actions/customer.household.actions';
import { apFormHasErrors } from '../../../main/customercare.page.helper';
import { isAddressValidFromAddressResponse } from '../../../shared/contextualComponents/address/address.validator.helper';
import { setForceShowEditFormAddress, validateAddress } from '../../../../reducers/actions/address.component.actions';
import { UnvalidatedAddressesSelector, ValidatedAddressesSelector } from '../../../../reducers/selectors/address.component.selectors';
import { FormattedEditCustomerSubscriberIdentitiesSelector } from '../../../../reducers/selectors/customer.information.selectors';
function CreateMemberPopupController($ngRedux, $timeout) {
  var _this = this;
  var disconnectRedux;
  var popupApi = null;
  var mapStateToTarget = function mapStateToTarget(store) {
    return {
      customerId: CurrentCustomerIdSelector(store),
      currentCustomerAccountingMethod: CurrentCustomerAccountingMethodSelector(store),
      driversLicenseStateOptions: CreateCustomerStateRegionProvinceValueOptions(store),
      enableProspectLiteForHousehold: EnableProspectLiteForHouseholdSelector(store),
      household: CurrentHouseholdSelector(store),
      formattedEditCustomerSubscriberIdentities: FormattedEditCustomerSubscriberIdentitiesSelector(store),
      isCreatingHouseholdMember: IsCreatingHouseholdMemberSelector(store),
      lastAttemptError: HouseholdErrorSelector(store),
      newMember: CreateChildCustomerSelector(store),
      selectedCustomerSubtenant: SelectedCustomerSubtenantSelector(store),
      selectedMember: SelectedHouseholdMemberSelector(store),
      selectedMemberId: SelectedHouseholdMemberIdSelector(store),
      unvalidatedAddresses: UnvalidatedAddressesSelector(store),
      validatedAddresses: ValidatedAddressesSelector(store)
    };
  };
  var controllerActions = {
    clearCreateEditCustomerForm: clearCreateEditCustomerForm,
    createEditCustomerFormChanged: createEditCustomerFormChanged,
    createHouseholdMember: createHouseholdMember,
    registerUnsavedChanges: UnsavedChangesPromptActions.registerUnsavedChanges,
    unregisterUnsavedChanges: UnsavedChangesPromptActions.unregisterUnsavedChanges,
    setForceShowEditFormAddress: setForceShowEditFormAddress,
    stateReload: stateReload,
    validateAddress: validateAddress
  };
  this.$onInit = function () {
    _this.showForm = false;
    _this.formErrors = [];
    _this.apErrors = [];
    disconnectRedux = $ngRedux.connect(mapStateToTarget, controllerActions)(function (state, actions) {
      _this.state = state;
      _this.actions = actions;
    });
    _this.customerCareKeys = CustomerCareLocaleKeys;
    _this.createSuccessMessage = i18n.translate(_this.customerCareKeys.HOUSEHOLD.CREATE_MEMBER_SUCCESS);

    //Clear the form on init
    _this.actions.clearCreateEditCustomerForm();
    // hook the popupApi
    var onRegisterApi = _this.config.onRegisterApi;
    _this.config.onRegisterApi = function (_ref) {
      var api = _ref.api;
      popupApi = Object.assign({}, api, {
        open: function open() {
          _this.showForm = true;
          var newMemberForInitialization = _this.state.newMember;
          newMemberForInitialization.SubscriberTypeDetails.AccountingMethod = _this.state.currentCustomerAccountingMethod;
          _this.actions.createEditCustomerFormChanged(newMemberForInitialization);
          _this.actions.registerUnsavedChanges('createCustomerForm', {
            isDirty: function isDirty() {
              return _this.createMemberFormWrapper && _this.createMemberFormWrapper.createCustomerForm ? _this.createMemberFormWrapper.createCustomerForm.$dirty : false;
            },
            setPristine: function setPristine() {
              if (_this.createMemberFormWrapper && _this.createMemberFormWrapper.createCustomerForm) {
                _this.createMemberFormWrapper.createCustomerForm.$setPristine();
              }
            }
          });

          // NOTE: must wait for the ng-if bound to showForm to operate, for the popup centering logic
          $timeout(function () {
            api.open();
          });
        }
      });
      onRegisterApi && onRegisterApi({
        api: popupApi
      });
    };
  };
  this.onFormChanged = function (newMember) {
    _this.actions.createEditCustomerFormChanged(newMember);
  };
  this.$onDestroy = function () {
    disconnectRedux();
  };
  this.onSubmit = function (form) {
    if (!_this.checkForErrors(form.$error)) {
      _this.validateAddressWithAPI().then(function () {
        var addressKey = _this.getAddressKey();
        var validatedAddress = _this.state.validatedAddresses[addressKey];
        if (!addressKey || validatedAddress && isAddressValidFromAddressResponse(validatedAddress)) {
          _this.actions.createHouseholdMember(_this.state.newMember, {
            HouseholdId: _this.state.household.Id
          }).then(function () {
            _this.successCallback(_this.createSuccessMessage);
          }).then(function () {
            _this.actions.stateReload();
          }).catch(_this.errorCallback);
        } else {
          _this.actions.setForceShowEditFormAddress(false);
          _this.formErrors = [{
            //translate and also get guidance from the doc writer
            translatedMessage: i18n.translate(_this.CustomerCareLocaleKeys.ADDRESS_COMPONENT.INVALID_ADDRESS_ERROR_MESSAGE)
          }];
        }
      }).catch(_this.errorCallback);
    }
  };
  this.errorCallback = function () {
    _this.formErrors = [_this.state.lastAttemptError.message];
  };
  this.successCallback = function (message) {
    _this.closePopup();
    _this.actions.unregisterUnsavedChanges('createCustomerForm');
    var onMemberCreated = _this.onMemberCreated;
    onMemberCreated && onMemberCreated()(message, _this.state.selectedMemberId);
    _this.createMemberFormWrapper.$setPristine();
    _this.createMemberFormWrapper.createCustomerForm.$setPristine();
  };
  this.checkForErrors = function (ngFormError) {
    _this.handleApErrors();
    var errorModelList = FormHelper.formHasErrors(ngFormError, getErrorLookupObject());
    _this.formErrors = errorModelList.concat(_this.apErrors);
    return _this.formErrors.length > 0;
  };
  this.handleApErrors = function () {
    var apErrors = _this.createMemberFormWrapper.createCustomerForm.addlApi ? _this.createMemberFormWrapper.createCustomerForm.addlApi.$error : null;
    _this.apErrors = apFormHasErrors(apErrors);
  };
  this.closePopup = function () {
    if (!_this.state.isCreatingHouseholdMember) {
      _this.actions.clearCreateEditCustomerForm();
      _this.formErrors = [];
      popupApi.close();
      _this.showForm = false;
    }
  };
  this.getAddressKey = function () {
    return pathOr(undefined, ['createMemberFormWrapper', 'createCustomerForm', 'addressWrapupController.singleAddressFormFormApi', 'addressKey'], _this);
  };
  this.getAddressKeyForAddressValidatedThroughAPI = function () {
    return pathOr(undefined, ['createMemberFormWrapper', 'createCustomerForm', 'addressWrapupController.singleAddressFormFormApi', 'keyForAddressValidatedThroughAPI'], _this);
  };
  this.getJobToken = function () {
    var addressKey = _this.getAddressKey(),
      addressKeyForAddressValidatedThroughAPI = _this.getAddressKeyForAddressValidatedThroughAPI(),
      validatedAddressForCurrentAddress = _this.state.validatedAddresses[addressKey],
      validatedAddressForAddressValidatedThroughAPI = _this.state.validatedAddresses[addressKeyForAddressValidatedThroughAPI];
    if (validatedAddressForCurrentAddress && validatedAddressForCurrentAddress.JobToken) {
      return validatedAddressForCurrentAddress.JobToken;
    } else if (validatedAddressForAddressValidatedThroughAPI && validatedAddressForAddressValidatedThroughAPI.JobToken) {
      return validatedAddressForAddressValidatedThroughAPI.JobToken;
    }
    return null;
  };
  this.validateAddressWithAPI = function () {
    var addressKey = _this.getAddressKey(),
      unvalidatedAddress = _this.state.unvalidatedAddresses[addressKey],
      validatedAddress = _this.state.validatedAddresses[addressKey],
      addressTypes = {
        DefaultBilling: true,
        DefaultHome: true,
        DefaultPostal: true,
        DefaultService: true
      };
    if (validatedAddress || !unvalidatedAddress) {
      return Promise.resolve(100);
    } else {
      return _this.actions.validateAddress(addressKey, unvalidatedAddress, _this.getJobToken(), addressTypes);
    }
  };
}
export default {
  template: require('./create.member.popup.html'),
  bindings: {
    config: '<',
    customerId: '<',
    onMemberCreated: '&',
    overrideValidations: '<?'
  },
  controllerAs: 'CreateMemberPopup',
  controller: CreateMemberPopupController
};